import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import { ConnectedRouter as Router } from 'react-router-redux';

import history from '../browser-history';
import configRoutes from '../routes';
import Actions from '../actions';
import spreeStore from '../store';

class Main extends Component {
    componentWillMount() {
        this.unlisten = history.listen((location, action) => {
            window.scrollTo(0, 0);
        });
    }

    componentDidMount() {
        this.props.updateConfigsActiveCart();
        if (window.zE) {
            window.zE('webWidget', 'setLocale', this.props.currentLocale);
        }

        // Listen to another tab's changes in the storage.
        // We need to keep the order sync across multiple tabs
        window.addEventListener('storage', (evt) => {
            const localData = JSON.parse(window.localStorage.getItem('localData'));
            const localState = spreeStore.getState();
            if (localData && localData.order && localState && localState.order) {
                if (JSON.stringify(localData.order) !== JSON.stringify(localState.order)) {
                    setTimeout(() => {
                        spreeStore.dispatch(Actions.syncOrderFromStorage(localData.order));
                    }, 0);
                }
            }
        });

        this.props.onTryAutoRefresh();
    }

    componentWillUnmount() {
        this.unlisten();
    }

    render() {
        return (
            <div>
                <Router history={history}>{configRoutes()}</Router>
                <ReduxToastr
                    timeOut={6000}
                    newestOnTop={false}
                    position="top-right"
                    getState={(state) => state.toastr} // This is the default
                    transitionIn="bounceIn"
                    transitionOut="bounceOut"
                    closeOnToastrClick
                    showCloseButton={false}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isAuthenticated: state.auth.token !== null,
    currentLocale: state.locale.currentLocale,
});

const mapDispatchToProps = (dispatch) => ({
    onTryAutoRefresh: () => dispatch(Actions.authCheckState()),
    updateConfigsActiveCart: () => dispatch(Actions.updateConfigsActiveCart()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);



/** WEBPACK FOOTER **
 ** ./src/components/main.jsx
 **/